<form [formGroup]="productForm" (ngSubmit)="addProduct()">
  <div class="p-fluid">
    <p-progressBar
      *ngIf="uploadPercent !== null"
      [value]="uploadPercent"
      class="mb-5"
    ></p-progressBar>

    <div class="p-field mb-3">
      <label for="name">Name</label>
      <input id="name" type="text" pInputText formControlName="name" />
    </div>
    <div class="p-field mb-3">
      <label for="description">Description</label>
      <textarea
        id="description"
        pInputTextarea
        formControlName="description"
      ></textarea>
    </div>
    <div class="p-field mb-3">
      <label for="unitPrice">Unit Price</label>
      <input
        id="unitPrice"
        type="number"
        pInputText
        formControlName="unitPrice"
      />
    </div>
    <div class="p-field mb-3">
      <label for="quantity">Quantity</label>
      <input
        id="quantity"
        type="number"
        pInputText
        formControlName="quantity"
      />
    </div>
    <div class="p-field mb-3">
      <label for="category">Category</label>
      <p-dropdown
        [options]="categories"
        optionLabel="name"
        formControlName="category"
      ></p-dropdown>
    </div>
    <div class="p-field mb-3">
      <label for="cover">Cover Image</label>
      <p-fileUpload
        mode="basic"
        name="cover"
        accept="image/*"
        [customUpload]="true"
        (onSelect)="onCoverSelected($event)"
      >
      </p-fileUpload>
    </div>
    <div class="p-field mb-3">
      <label for="images">Additional Images</label>
      <p-fileUpload
        mode="advanced"
        name="images"
        [multiple]="true"
        accept="image/*"
        [customUpload]="true"
        (onSelect)="onAdditionalImagesSelected($event)"
      >
      </p-fileUpload>
    </div>
    <div class="p-field-checkbox mb-3" *ngIf="verified">
      <p-checkbox formControlName="verified" [binary]="true"></p-checkbox>
      <label for="verified">Verified</label>
    </div>
    <div class="p-field-checkbox mb-3">
      <p-checkbox formControlName="shown" [binary]="true"></p-checkbox>
      <label for="shown">Shown</label>
    </div>
    <button
      pButton
      type="submit"
      label="Add Product"
      [disabled]="productForm.invalid"
    ></button>
    
  </div>
</form>
